import React from "react"
import { Box } from "@material-ui/core"
import {Text} from "gatsby-theme-material-foundry"
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  EmailShareButton,
  EmailIcon
} from "react-share"

function ShareList({ url }) {
  return (
    <Box
      pt={2}
      display="flex"
      justifyContent="space-between"
      alignContent="center"
    >
      <FacebookShareButton url={url}>
        <FacebookIcon size={32} round />
      </FacebookShareButton>
      <TwitterShareButton url={url}>
        <TwitterIcon size={32} round />
      </TwitterShareButton>
      <EmailShareButton url={url}>
        <EmailIcon size={32} round />
      </EmailShareButton>
      <Text black style={{marginTop: "2px"}}><strong>#hvlskape</strong></Text>
    </Box>

  )
}

export default ShareList
